import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18a137d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "alert",
  class: "oxd-time-picker"
}
const _hoisted_2 = { class: "oxd-time-hour-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "oxd-time-seperator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "oxd-time-seperator-icon" }, ":")
], -1))
const _hoisted_4 = { class: "oxd-time-minute-input" }
const _hoisted_5 = { class: "oxd-time-period-input" }
const _hoisted_6 = { class: "oxd-time-period-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "am" }, "AM", -1))
const _hoisted_8 = { class: "oxd-time-period-label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pm" }, "PM", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon_button = _resolveComponent("oxd-icon-button")!
  const _component_oxd_input = _resolveComponent("oxd-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_oxd_icon_button, {
        name: "chevron-up",
        class: "oxd-time-hour-input-up",
        role: "none",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.increment(1, 'hour'))),
        withContainer: false
      }),
      _createVNode(_component_oxd_input, {
        value: _ctx.hour,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChange($event, 'hour'))),
        class: "oxd-time-hour-input-text"
      }, null, 8, ["value"]),
      _createVNode(_component_oxd_icon_button, {
        name: "chevron-down",
        class: "oxd-time-hour-input-down",
        role: "none",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.decrement(1, 'hour'))),
        withContainer: false
      })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_oxd_icon_button, {
        name: "chevron-up",
        class: "oxd-time-minute-input-up",
        role: "none",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.increment(_ctx.step, 'minute'))),
        withContainer: false
      }),
      _createVNode(_component_oxd_input, {
        value: _ctx.minute,
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChange($event, 'minute'))),
        class: "oxd-time-minute-input-text"
      }, null, 8, ["value"]),
      _createVNode(_component_oxd_icon_button, {
        name: "chevron-down",
        class: "oxd-time-minute-input-down",
        role: "none",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.decrement(_ctx.step, 'minute'))),
        withContainer: false
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          name: "am",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.period) = $event)),
          type: "radio",
          value: "AM"
        }, null, 512), [
          [_vModelRadio, _ctx.period]
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          name: "pm",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.period) = $event)),
          type: "radio",
          value: "PM"
        }, null, 512), [
          [_vModelRadio, _ctx.period]
        ]),
        _hoisted_9
      ])
    ])
  ]))
}